export default "__VITE_PUBLIC_ASSET__19961331__"